import {RockBottom} from "../RockBottom";
import {Layers, RockBottomLayers, SimpleStageLayer} from "./RockBottomLayers";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class RockBottomReelBackground extends PIXI.Container {
    private _reelFrame: PIXI.Sprite;
    private _layer: SimpleStageLayer | undefined;
    private _overlay: PIXI.Graphics;
    private _reelFrameNormalTexture: PIXI.Texture;
    private _reelFrameAntiTexture: PIXI.Texture;

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    public onAnticipation(show: boolean): void {
        if(RockBottom.inBonusGame) {
            return;
        }
        if (!RockBottom.model.isRestore) {
            if (show) {
                this._overlay.visible = true;
                this._overlay.alpha = 0;
                TweenLite.to(this._overlay, RockBottomGameConfig.FADE_DUR_ANTICIPATION, {
                    alpha: 1,
                    onComplete: () => {
                        this._reelFrame.texture = this._reelFrameAntiTexture;
                    }
                });
            } else {
                this._overlay.alpha = 1;
                TweenLite.to(this._overlay, RockBottomGameConfig.FADE_DUR_ANTICIPATION, {
                    alpha: 0,
                    onComplete: () => {
                        this._overlay.visible = false;
                        this._reelFrame.texture = this._reelFrameNormalTexture;
                    }
                });
            }
        }
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.REEL_BACKGROUND);
        this.setFrameTextures();
        this.createOverlay();
        this.createReelFrame();
        this._layer?.addChild(this);
    }

    private setFrameTextures(): void {
        this._reelFrameNormalTexture = RockBottom.assetLoader.getTextures("reelBackground")[0];
        this._reelFrameAntiTexture = RockBottom.assetLoader.getTextures("reelBackgroundAnti")[0];
    }

    private createReelFrame(): void {
        this._reelFrame = new PIXI.Sprite(this._reelFrameNormalTexture);
        this._reelFrame.anchor.set(0.5, 0.5);
        this._reelFrame.position.set(360);
        this.addChild(this._reelFrame);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this.setOverlayProps();
        this.addChild(this._overlay);
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private setOverlayProps(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 0.75);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
    }
}